"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermLifeValidationUtils = void 0;
var ValidationUtils_1 = require("../ValidationUtils");
var CASTermMaxFace = require("../../config/coverpath/CASTerm/ActualAgeToMaxTotalFace.json");
var CASTermMinFace = require("../../config/coverpath/CASTerm/ActualAgeToMinTotalFace.json");
var CASTermMinAge = require("../../config/coverpath/CASTerm/TermToMinActualAge.json");
var CASTermMaxAgeSmoker = require("../../config/coverpath/CASTerm/TermToMaxActualAge-Smoker.json");
var CASTermMaxAgeNonSmoker = require("../../config/coverpath/CASTerm/TermToMaxActualAge-NonSmoker.json");
var CASTermMaxFaceNonUsCitizen = require("../../config/coverpath/CASTerm/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var MMDirectTermMaxFace = require("../../config/coverpath/MMDirectTerm/ActualAgeToMaxTotalFace.json");
var MMDirectTermMinFace = require("../../config/coverpath/MMDirectTerm/ActualAgeToMinTotalFace.json");
var MMDirectTermMinAge = require("../../config/coverpath/MMDirectTerm/TermToMinActualAge.json");
var MMDirectTermMaxAgeSmoker = require("../../config/coverpath/MMDirectTerm/TermToMaxActualAge-Smoker.json");
var MMDirectTermMaxAgeNonSmoker = require("../../config/coverpath/MMDirectTerm/TermToMaxActualAge-NonSmoker.json");
var MMDirectTermMaxFaceNonUsCitizen = require("../../config/coverpath/MMDirectTerm/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var CASTermECPMaxFace = require("../../config/coverpath/CASTermECP/ActualAgeToMaxTotalFace.json");
var CASTermECPMinFace = require("../../config/coverpath/CASTermECP/ActualAgeToMinTotalFace.json");
var CASTermECPMinAge = require("../../config/coverpath/CASTermECP/TermToMinActualAge.json");
var CASTermECPMaxAgeSmoker = require("../../config/coverpath/CASTermECP/TermToMaxActualAge-Smoker.json");
var CASTermECPMaxAgeNonSmoker = require("../../config/coverpath/CASTermECP/TermToMaxActualAge-NonSmoker.json");
var CASTermECPMaxFaceNonUsCitizen = require("../../config/coverpath/CASTermECP/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var MMDirectTermECPMaxFace = require("../../config/coverpath/MMDirectTerm/ActualAgeToMaxTotalFace.json");
var MMDirectTermECPMinFace = require("../../config/coverpath/MMDirectTermECP/ActualAgeToMinTotalFace.json");
var MMDirectTermECPMinAge = require("../../config/coverpath/MMDirectTermECP/TermToMinActualAge.json");
var MMDirectTermECPMaxAgeSmoker = require("../../config/coverpath/MMDirectTermECP/TermToMaxActualAge-Smoker.json");
var MMDirectTermECPMaxAgeNonSmoker = require("../../config/coverpath/MMDirectTermECP/TermToMaxActualAge-NonSmoker.json");
var MMDirectTermECPMaxFaceNonUsCitizen = require("../../config/coverpath/MMDirectTermECP/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var ET10MaxFace = require("../../config/coverpath/ET10/ActualAgeToMaxTotalFace.json");
var ET10MinFace = require("../../config/coverpath/ET10/ActualAgeToMinTotalFace.json");
var ET10MinAge = require("../../config/coverpath/ET10/TermToMinActualAge.json");
var ET10MaxAge = require("../../config/coverpath/ET10/TermToMaxActualAge.json");
var ET10MaxFaceNonUsCitizen = require("../../config/coverpath/ET10/ActualAgeToMaxTotalFaceNonUsCitizen.json");
var TermLifeValidationUtils = /** @class */ (function () {
    function TermLifeValidationUtils() {
    }
    TermLifeValidationUtils.getAgeLookUpKeyForDOB = function (actualAge) {
        //the config is stored in 1/2 year increments so round down to nearest 1/2
        return ValidationUtils_1.ValidationUtils.roundDownToNearestIncrement(actualAge, .5).toFixed(1);
    };
    TermLifeValidationUtils.isValidDOBForProduct = function (productCode, dob) {
        var configs = TermLifeValidationUtils.getMaxFaceConfigs(productCode);
        var actualAge = ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob);
        var actualAgeLookUpKey = TermLifeValidationUtils.getAgeLookUpKeyForDOB(actualAge);
        var minAllowed = configs.actualAgeToMinTotalFace[actualAgeLookUpKey];
        var maxAllowed = configs.actualAgeToMaxTotalFace[actualAgeLookUpKey];
        if (!minAllowed || !maxAllowed) {
            return {
                isValid: false,
                message: "Selected product not allowed for this age"
            };
        }
        else {
            return { isValid: true };
        }
    };
    TermLifeValidationUtils.isValidFaceAmount = function (productCode, faceAmount, dob, isUsCitizen) {
        if (isUsCitizen === void 0) { isUsCitizen = true; }
        var configs = TermLifeValidationUtils.getMaxFaceConfigs(productCode);
        var actualAge = ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob);
        var actualAgeLookUpKey = TermLifeValidationUtils.getAgeLookUpKeyForDOB(actualAge);
        var minAllowed = configs.actualAgeToMinTotalFace[actualAgeLookUpKey];
        var maxAllowed = isUsCitizen ? configs.actualAgeToMaxTotalFace[actualAgeLookUpKey] : configs.actualAgeToMaxTotalFaceNonUsCitizen[actualAgeLookUpKey];
        if (!minAllowed || !maxAllowed) {
            return {
                isValid: false,
                message: "Selection not allowed given age"
            };
        }
        if (faceAmount < minAllowed) {
            return {
                isValid: false,
                minAllowed: minAllowed,
                message: "Must be at least ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(minAllowed))
            };
        }
        if (faceAmount > maxAllowed) {
            return {
                isValid: false,
                maxAllowed: maxAllowed,
                message: "Cannot exceed ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(maxAllowed))
            };
        }
        return {
            isValid: true
        };
    };
    TermLifeValidationUtils.getMaxFaceConfigs = function (productCode) {
        if (productCode === 'CASTerm') {
            return {
                actualAgeToMinTotalFace: CASTermMinFace,
                actualAgeToMaxTotalFace: CASTermMaxFace,
                actualAgeToMaxTotalFaceNonUsCitizen: CASTermMaxFaceNonUsCitizen
            };
        }
        else if (productCode === 'MMDirectTerm') {
            return {
                actualAgeToMinTotalFace: MMDirectTermMinFace,
                actualAgeToMaxTotalFace: MMDirectTermMaxFace,
                actualAgeToMaxTotalFaceNonUsCitizen: MMDirectTermMaxFaceNonUsCitizen
            };
        }
        else if (productCode === 'CASTermECP') {
            return {
                actualAgeToMinTotalFace: CASTermECPMinFace,
                actualAgeToMaxTotalFace: CASTermECPMaxFace,
                actualAgeToMaxTotalFaceNonUsCitizen: CASTermECPMaxFaceNonUsCitizen
            };
        }
        else if (productCode === 'MMDirectTermECP') {
            return {
                actualAgeToMinTotalFace: MMDirectTermECPMinFace,
                actualAgeToMaxTotalFace: MMDirectTermECPMaxFace,
                actualAgeToMaxTotalFaceNonUsCitizen: MMDirectTermECPMaxFaceNonUsCitizen
            };
        }
        else if (productCode === 'ET10') {
            return {
                actualAgeToMinTotalFace: ET10MinFace,
                actualAgeToMaxTotalFace: ET10MaxFace,
                actualAgeToMaxTotalFaceNonUsCitizen: ET10MaxFaceNonUsCitizen
            };
        }
        else {
            throw new Error("Cannot get config for productCode ".concat(productCode));
        }
    };
    TermLifeValidationUtils.isValidTerm = function (productCode, term, dob, isSmoker) {
        var configs = TermLifeValidationUtils.getMaxAgeForTermConfigs(productCode, isSmoker);
        var minActualAgeForTerm = configs.termToMinActualAge[term.toFixed(0)];
        var maxActualAgeForTerm = configs.termToMaxActualAge[term.toFixed(0)];
        if (!maxActualAgeForTerm) {
            return {
                isValid: false,
                message: "Could not validate term"
            };
        }
        var actualAge = ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob);
        if (actualAge >= minActualAgeForTerm && actualAge < maxActualAgeForTerm) {
            return { isValid: true };
        }
        else {
            return { isValid: false, message: 'Term not allowed given age and/or tobacco use' };
        }
    };
    TermLifeValidationUtils.getMaxAgeForTermConfigs = function (productCode, isSmoker) {
        if (productCode === 'CASTerm') {
            var minAge = CASTermMinAge;
            var maxAge = void 0;
            if (isSmoker) {
                maxAge = CASTermMaxAgeSmoker;
            }
            else {
                maxAge = CASTermMaxAgeNonSmoker;
            }
            return {
                termToMinActualAge: minAge,
                termToMaxActualAge: maxAge
            };
        }
        else if (productCode === 'MMDirectTerm') {
            var minAge = MMDirectTermMinAge;
            var maxAge = void 0;
            if (isSmoker) {
                maxAge = MMDirectTermMaxAgeSmoker;
            }
            else {
                maxAge = MMDirectTermMaxAgeNonSmoker;
            }
            return {
                termToMinActualAge: minAge,
                termToMaxActualAge: maxAge
            };
        }
        else if (productCode === 'CASTermECP') {
            var minAge = CASTermECPMinAge;
            var maxAge = isSmoker ? CASTermECPMaxAgeSmoker : CASTermECPMaxAgeNonSmoker;
            return {
                termToMinActualAge: minAge,
                termToMaxActualAge: maxAge
            };
        }
        else if (productCode === 'MMDirectTermECP') {
            var minAge = MMDirectTermECPMinAge;
            var maxAge = isSmoker ? MMDirectTermECPMaxAgeSmoker : MMDirectTermECPMaxAgeNonSmoker;
            return {
                termToMinActualAge: minAge,
                termToMaxActualAge: maxAge
            };
        }
        else if (productCode === 'ET10') {
            return {
                termToMinActualAge: ET10MinAge,
                termToMaxActualAge: ET10MaxAge
            };
        }
        else {
            throw new Error("Cannot get config for productCode ".concat(productCode));
        }
    };
    return TermLifeValidationUtils;
}());
exports.TermLifeValidationUtils = TermLifeValidationUtils;
